/**
 * Reusable modal styles utility for responsive modal components
 * Provides consistent styling across signup and login modals
 */

export const getResponsiveModalStyles = () => {
  return `
    /* Extra Large screens - maximize modal width */
    @media (min-width: 1600px) {
      .modal-dialog.modal-xl {
        max-width: 1400px !important;
        width: 90% !important;
      }
      .half-col-2 {
        font-family: 'inter';
      }
      .half-col-2 .image-section {
        max-width: 800px !important;
      }
      .half-col-2 .image-section h2 {
        margin-top: 10px;
        font-size: 1.3rem !important;
        line-height: 1.2 !important;
      }
      .half-col-2 .image-section img {
        max-height: 80% !important;
      }
    }

    /* Large screens - increased modal width */
    @media (min-width: 1400px) and (max-width: 1599px) {
      .modal-dialog.modal-xl {
        max-width: 1300px !important;
        width: 88% !important;
      }
      .half-col-2 {
        font-family: 'inter';
      }
      .half-col-2 .image-section {
        max-width: 750px !important;
      }
      .half-col-2 .image-section h2 {
        margin-top: 10px;
        font-size: 1.3rem !important;
        line-height: 1.2 !important;
      }
      .half-col-2 .image-section img {
        max-height: 400px !important;
      }
    }

    /* Standard large screens */
    @media (min-width: 1200px) and (max-width: 1399px) {
      .modal-dialog.modal-xl {
        max-width: 1200px !important;
        width: 100% !important;
      }
      .half-col-2 .image-section {
        max-width: 700px !important;
      }
      .half-col-2 .image-section h2 {
        margin-top: 10px;
        font-size: 1.2rem !important;
        line-height: 1.2 !important;
      }
      .half-col-2 .image-section img {
        max-height: 100% !important;
      }
    }

    /* Medium-large screens */
    @media (min-width: 992px) and (max-width: 1199px) {
      .modal-dialog.modal-xl {
        max-width: 1000px !important;
        width: 90% !important;
      }
      .half-col-2 {
        font-family: 'inter';
      }
      .half-col-2 .image-section {
        margin-bottom: 5px !important;
        max-width: 600px !important;
      }
      .half-col-2 .image-section h2 {
        font-size: 1.2rem !important;
        line-height: 1.2 !important;
      }
      .half-col-2 .image-section img {
        max-height: 320px !important;
      }
    }

    /* Medium screens */
    @media (min-width: 768px) and (max-width: 991px) {
      .modal-dialog.modal-xl {
        max-width: 850px !important;
        width: 95% !important;
      }
      .half-col-2 .image-section {
        max-width: 500px !important;
      }
      .half-col-2 .image-section h2 {
        font-size: 1.3rem !important;
      }
      .half-col-2 .image-section img {
        max-height: 70% !important;
      }
    }

    @media (max-width: 800px) {
      .half-col-2 {
        font-family: 'inter';
        width: 100% !important;
        max-width: 100% !important;
        max-height: 100% !important;
      }
    }

    /* Small tablets */
    @media (min-width: 576px) and (max-width: 767px) {
      .modal-dialog.modal-xl {
        max-width: 95% !important;
        width: 95% !important;
        margin: 1rem auto !important;
      }
      .half-col-2 .image-section h2 {
        font-size: 1.2rem !important;
        margin-bottom: 12px !important;
      }
      .half-col-2 .image-section img {
        max-height: 220px !important;
      }
      .half-col-2 {
        font-family: 'inter';
        padding: 12px !important;
      }
    }

    /* Mobile screens */
    @media (max-width: 575px) {
      .modal-dialog.modal-xl {
        max-width: 98% !important;
        width: 98% !important;
        margin: 0.5rem auto !important;
        height: 98vh !important;
      }
      .modal-content.coachmark-wrapper {
        height: 98vh !important;
        border-radius: 0 !important;
      }
      .half-col-2 .image-section img {
        max-height: 180px !important;
      }
    }

    /* Small mobile responsive */
    @media (max-width: 800px) {
      .modal-dialog.modal-xl {
        height: 100vh !important;
        margin: 0 !important;
        max-width: 100% !important;
        width: 100% !important;
      }
      .modal-content.coachmark-wrapper {
        height: 100vh !important;
        border-radius: 0 !important;
      }
    }

    /* Override Bootstrap's default modal-xl max-width */
    .modal-dialog.modal-xl {
      max-width: 1140px !important;
    }

    /* Custom 40/60 layout for modal columns */
    .half-col-1 {
      overflow-y: auto !important;
      flex: 0 0 50% !important;
      max-width: 50% !important;
      width: 50% !important;
    }

    .half-col-2 {
      flex: 0 0 50% !important;
      max-width: 50% !important;
      width: 50% !important;
    }

    /* Responsive adjustments for screens below 800px */
    @media (max-width: 799px) {
      .half-col-1 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
        width: 100% !important;
      }
      .half-col-2 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
        width: 100% !important;
      }
    }

    @media (max-width: 800px) {
      .half-col-1 {
        max-height: 100% !important;
      }
    }

    /* Responsive styling for simple text */
    @media (max-width: 768px) {
      .half-col-2 .image-section h4 {
        font-size: 0.95rem !important;
        margin-bottom: 10px !important;
      }
      .half-col-2 .image-section div[style*="fontSize: 0.9rem"] {
        font-size: 0.85rem !important;
      }
    }

    /* Ensure proper scrolling for right side */
    .half-col-2 {
      overflow-y: auto !important;
      overflow-x: hidden !important;
    }
  `;
};

/**
 * Class component utility to manage modal styles lifecycle
 * Use this in class components' componentDidMount and componentWillUnmount
 */
export const addModalStyles = (componentInstance) => {
  // Check if styles already exist to avoid duplicates
  const existingStyle = document.getElementById("responsive-modal-styles");
  if (existingStyle) {
    return existingStyle;
  }

  const style = document.createElement("style");
  style.id = "responsive-modal-styles";
  style.textContent = getResponsiveModalStyles();
  document.head.appendChild(style);

  // Store reference for cleanup
  componentInstance.styleElement = style;
  return style;
};

export const removeModalStyles = (componentInstance) => {
  if (componentInstance.styleElement) {
    document.head.removeChild(componentInstance.styleElement);
    componentInstance.styleElement = null;
  }
};
